import { render, staticRenderFns } from "./modificarDependencia.vue?vue&type=template&id=57492a66"
import script from "./modificarDependencia.vue?vue&type=script&lang=js"
export * from "./modificarDependencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports